export const Experiments = {
  b2c_059_donate_to_yourself_v3: 'b2c_059_donate_to_yourself_v3',
  donate_now_track_click: 'donate_now_track_click',

  TrackingEvents: {
    donateButtonClick: 'donateButtonClick',
    shareModalOpen: 'shareModalOpen',
    shareSocialButtonClick: 'shareSocialButtonClick',
  },

  CustomBrandingFrpFeature: {
    featureKey: 'custom_branding_on_fundraising_pages',
    customBrandingFrpAbExperiment: {
      experimentKey: 'custom_branding_on_fundraising_pages',
      variations: {
        charityBranding: 'charity-branding',
        jgDefaultColours: 'jg-default-colours',
      },
    },
  },
};
